import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const PrPurchaseReqviewsingle = () => {
  useAuthRedirect();
    const {priorNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [indentView, setIndentView] = useState({});
  const [indentView1, setIndentView1] = useState({});
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({  
        fright : "",
        payment : "",
        pf: "",
        delivery: "",
        warrenty: ""});
const navigate = useNavigate();
const canEntry = hasPermission("Prior Purchase Requisition", "entry");


useEffect(() => {
  const fetchPRPurchaseDetails = async () => {
    Swal.fire({
      title: "Fetching PR Details...",
      html: `
        <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
        </div>
        <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch header and supplier details...</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        if (!document.getElementById("progressBarStyle")) {
          const style = document.createElement("style");
          style.id = "progressBarStyle";
          style.innerHTML = `
            @keyframes progressBar {
              0% { width: 0% }
              50% { width: 100% }
              100% { width: 0% }
            }
          `;
          document.head.appendChild(style);
        }
      }
    });

    try {
      const [headerRes, supplierRes] = await Promise.all([
        axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_detailsHeader?priorNo=${priorNo}`),
        axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_detailsHeader1?priorNo=${priorNo}&branch=${branch}`)
      ]);

      // First API response
      if (headerRes.data?.headerDetails?.length > 0) {
        const item = headerRes.data.headerDetails[0];
        setIndentView({
          prHeader_number: item.prHeader_number || "N/A",
          branchmaster_name: item.branchmaster_name || "N/A",
          prHeader_hod: item.prHeader_hod || "N/A",
          prHeader_remarks: item.prHeader_remarks || "N/A",
          prHeader_date: item.prHeader_date || "N/A",
          prHeader_headMaterial: item.prHeader_headMaterial || "N/A",
          freight_charges: item.freight_charges || "N/A",
        });
      }

      // Second API response
      if (supplierRes.data?.headerDetails1?.length > 0) {
        const item1 = supplierRes.data.headerDetails1[0];
        setIndentView1({
          prDetail_supplierCode: item1.PrDetail_supplierCode || "N/A",
          supplierMaster_name: item1.supplierMaster_name || "N/A",
        });
        setData(supplierRes.data.headerDetails1);
      }
    } catch (error) {
      console.error("Error fetching PR Purchase data:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to Fetch Data",
        text: "Something went wrong while fetching PR Purchase details.",
      });
    } finally {
      Swal.close();
    }
  };
{canEntry && (
  fetchPRPurchaseDetails()
)}
}, [priorNo, branch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //  if (!formData.fright.trim()) {
    //           Swal.fire({
    //             icon: 'warning',
    //             title: 'Empty Field',
    //             text: 'Please enter Fright Charge!',
    //           });
    //           return;
    //         }

            if (isNaN(formData.fright) || Number(formData.fright) <= 0) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Invalid Quantity',
                  text: `Enter Freight Charge and must be a positive number.`,
                });
                return;
              }

              if (!formData.payment.trim()) {
              Swal.fire({
                icon: 'warning',
                title: 'Empty Field',
                text: 'Please Enter Payment Method!',
              });
              return;
            }

             if (!formData.delivery.trim()) {
              Swal.fire({
                icon: 'warning',
                title: 'Empty Field',
                text: 'Please Enter Delivery Place!',
              });
              return;
            }

            const pfValue = Number(formData.pf);

if (isNaN(pfValue)) {
  Swal.fire({
    icon: "warning",
    title: "Invalid PF",
    text: "PF must be a number.",
  });
  return;
}

if (pfValue < 0 || pfValue > 100) {
  Swal.fire({
    icon: "warning",
    title: "Invalid PF",
    text: "PF percentage must be between 0 and 100.",
  });
  return;
}


    const payload = {
        fright : formData.fright,
        payment : formData.payment,
        pf: formData.pf,
        delivery: formData.delivery,
        warrenty: formData.warrenty,
        branch : branch,
        prNo : priorNo,
    };
console.log(payload);

    try {
        Swal.fire({
            title: "Submitting...",
            text: "Please wait while we process your request.",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
        const response = await axios.put(
            "https://rfs2.infraconsoft.net.in/api/purchaseReq_frightInsert",
            payload
        );
        // console.log(response);
        // alert("success");
        Swal.fire("Success", "Freight Chagres added successfully", "success");
        
        navigate('/inventory/prView');

    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
};



  if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                              <h2 className="add-txt">Prior Purchase Requisition - Add Freight</h2>
                              <Link to='/inventory/prview'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                              </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit} >
          <div className="form-row">
              <div className="form-group">
                <label>Prior Pr Req No :</label>
                <input type="text" name="indentNo" value={indentView.prHeader_number} readOnly/>
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
  type="text"
  name="endhrs"
  value={indentView.prHeader_date ? new Date(indentView.prHeader_date).toISOString().split("T")[0] : ""}
 readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="indentNo" value={indentView1.prDetail_supplierCode} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" value={indentView1.supplierMaster_name} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Branch :</label>
                <input type="text" name="indentNo" value={indentView.branchmaster_name} readOnly/>
              </div>
              <div className="form-group">
                <label>HOD :</label>
                <input type="text" value={indentView.prHeader_hod} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={indentView.prHeader_remarks} name="remarks" readOnly />
              </div>
              <div className="form-group">
                <label>Indenter</label>
                <input type="text" value={indentView.prHeader_headMaterial} name="remarks" readOnly />
              </div>
            </div>


            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Freight Charges</th>
                    <th>Payment</th>
                    <th>P&F</th>
                    <th>Delivery</th>
                    <th>Warrenty</th>
                  </tr>
                </thead>
                <tbody>
        
                {indentView.freight_charges > 0 ? (
  <tr>
    <td colSpan={6}>Already Added</td>
  </tr>
) : (
  <tr>
    <td>1</td>
    <td>
      <input type="number" name="fright" value={formData.fright} onChange={handleChange} />
    </td>
    <td>
      <input type="text" name="payment" value={formData.payment} onChange={handleChange} />
    </td>
    <td>
      <input type="number" name="pf" value={formData.pf} onChange={handleChange} />
    </td>
    <td>
      <input type="text" name="delivery" value={formData.delivery} onChange={handleChange} />
    </td>
    <td>
      <input type="number" name="warrenty" value={formData.warrenty} onChange={handleChange} />
    </td>
  </tr>
)}

</tbody>

              </table>
            </div>
            {indentView.freight_charges > 0 ? (
  <p></p>
) : (
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Update
              </button>
            </div>
            )}
          </form>
        </div>
      </div>

    </div>
  );
};

export default PrPurchaseReqviewsingle;
